import axios from 'axios'
import config from '../config'

export default {
    getServerBalancers(id) {
        return axios.get(config.publicPath + 'pmta/server/' + id + '/balancers')
    },
    balancersConfigUpload(data) {
        return axios.post(config.publicPath + 'pmta/server/balancers/upload', data, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        })
    },
    deleteBalancer(id) {
        return axios.delete(config.publicPath + 'pmta/server/balancers/delete/' + id);
    }
}